// extracted by mini-css-extract-plugin
export default {"container":"SelectEditTemplate__container___xgMHf"};